import {Component, ElementRef, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import Required from '@util/decorators/required';
import {FileDropDirective} from '@util/directives/file-drop.directive';
import {CommonModule} from '@angular/common';

@Component({
  selector: 'app-dropzone',
  templateUrl: './dropzone.component.html',
  styleUrls: ['./dropzone.component.scss'],
  standalone: true,
  imports: [CommonModule, FileDropDirective],
})
export class DropzoneComponent {
  @ViewChild('FileUpload') fileInput: ElementRef;

  @Output() fileListChange = new EventEmitter<FileList>();
  dropzoneActive = false;

  @Required @Input() maxFileSize: number;
  @Input() message = '';
  @Input() accept = '*';
  @Input() size: 'normal' | 'small' = 'normal';
  @Input() disabled = false;

  handleNewFiles(event: FileList) {
    this.fileListChange.emit(event);
  }

  /** The change event on the input will not trigger if a File is added, removed and added again unless it's value will is reset */
  resetFileInput() {
    this.fileInput.nativeElement.value = null;
  }

  dropzoneState($event: boolean) {
    this.dropzoneActive = $event;
  }

  get maxFileSizeMb(): string {
    const n = Math.floor(this.maxFileSize / 1000 / 1000);
    return `${n} MB`;
  }
}
